import React from 'react';
import { colorwayFor, chipsFor } from '../colorways';
import { IconPlus } from '../icons';

export default function HomeView({ children, rewardCount, landedId, onSelectChild, onGoAdmin, headingRef }) {
  // No "biggest stack" cell: naming a winning sibling in the first viewport
  // ranks 5-to-12-year-olds against each other every time the app is opened.
  const total = children.reduce((sum, c) => sum + c.tokens, 0);

  return (
    <div className="home-view">
      <header className="page-head">
        <h1 tabIndex={-1} ref={headingRef}>The Board</h1>
        <p>
          Every token this family has earned, box by box. Open a box to add tokens or
          spend them.
        </p>
      </header>

      {children.length === 0 ? (
        <div className="empty">
          <h2>The wall is empty</h2>
          <p>
            No boxes on the shelf yet. Add the first child in the grown-ups area and
            their box goes up here.
          </p>
          <button type="button" className="btn btn--primary" onClick={onGoAdmin}>
            <IconPlus />
            Add the first child
          </button>
        </div>
      ) : (
        <>
          <ul className="wall">
            {children.map(child => {
              const { primary, secondary } = colorwayFor(child.id);
              return (
                <li key={child.id}>
                  <button
                    type="button"
                    className="box"
                    onClick={() => onSelectChild(child)}
                  >
                    <span className="box-body">
                      <span className="box-name">{child.name}</span>
                      <span className="box-sub">
                        {primary.name} / {secondary.name}
                      </span>
                      <span className="box-rule" role="presentation" />
                      <span className="box-figure">
                        {/* the balance lands on the wall too, so the child
                            watching the board sees the change, not just the
                            grown-up holding the phone */}
                        <span
                          key={`${child.id}-${child.tokens}`}
                          className={`fig${child.id === landedId ? ' fig--landed' : ''}`}
                        >
                          {child.tokens}
                        </span>
                        <span className="unit" aria-hidden="true">
                          {child.tokens === 1 ? 'Token' : 'Tokens'}
                        </span>
                      </span>
                      <span className="sr-only">
                        {child.tokens === 1 ? '1 token' : `${child.tokens} tokens`}. Open
                        {' '}{child.name}&rsquo;s box.
                      </span>
                    </span>
                    <span className="box-chips" aria-hidden="true">
                      {chipsFor(child.id).map((chip, i) => (
                        <span key={i} style={{ background: chip.hex, flexGrow: chip.grow }} />
                      ))}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>

          <dl className="ledger">
            <div className="ledger-cell">
              <dt>Tokens on the wall</dt>
              <dd>{total}</dd>
            </div>
            <div className="ledger-cell">
              <dt>Boxes</dt>
              <dd>{children.length}</dd>
            </div>
            <div className="ledger-cell">
              <dt>On the shelf</dt>
              <dd>
                {rewardCount}
                <small>rewards</small>
              </dd>
            </div>
          </dl>
        </>
      )}
    </div>
  );
}
